
// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import ReactPaginate from "react-paginate";
// import { AiOutlineDownload } from "react-icons/ai";
// import { FaGamepad, FaWallet, FaGift, FaExclamationTriangle, FaArrowUp, FaArrowDown } from "react-icons/fa";
// import Invoice from "./Invoice";
// import Spinner from "react-bootstrap/Spinner";
// import { Button } from "@mui/material";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import PaidIcon from '@mui/icons-material/Paid';
// import { IoIosRefresh } from "react-icons/io";
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';


// // Custom styles for a more compact and attractive theme
// const styles = {
//   container: {
//     background: "#f7f8fc", // Light gray background
//     minHeight: "100vh",
//     paddingTop: "10px",
//   },
//   card: {
//     borderRadius: "12px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
//     background: "#ffffff",
//     border: "1px solid #e0e0e0",
//     padding: "0px", // Minimal padding on the card itself
//   },
//   // The main content area of the card
//   cardBody: {
//     display: 'flex',
//     alignItems: 'center',
//     padding: '12px 15px',
//   },
//   iconBox: (color) => ({
//     backgroundColor: color,
//     color: "#fff",
//     borderRadius: "8px",
//     width: "40px",
//     height: "40px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     marginRight: "15px",
//     flexShrink: 0, // Prevent shrinking
//   }),
//   mainDetails: {
//     flexGrow: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     minWidth: 0,
//   },
//   amountText: (color) => ({
//     fontWeight: "700",
//     fontSize: "16px",
//     color: color,
//     whiteSpace: 'nowrap',
//   }),
//   detailLabel: {
//     fontSize: "10px",
//     color: "#999",
//     fontWeight: "600",
//     textTransform: "uppercase",
//   },
//   detailValue: {
//     fontSize: "12px",
//     fontWeight: "600",
//     color: "#333",
//   },
//   footer: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '8px 15px',
//     borderTop: '1px dashed #f0f0f0',
//     fontSize: '11px',
//     color: '#666',
//   },
//   tabButton: {
//     borderRadius: "20px",
//     padding: "6px 11px",
//     fontWeight: "600",
//     fontSize: "13px",
//     transition: "background-color 0.3s, color 0.3s",
//   },
//   activeTab: {
//     backgroundColor: "#0047AB",
//     color: "#fff",
//     border: "1px solid #0047AB",
//     boxShadow: "0 2px 5px rgba(0, 71, 171, 0.2)",
//   },
//   inactiveTab: {
//     backgroundColor: "transparent",
//     color: "#6c757d",
//     border: "1px solid #ced4da",
//   }
// };

// // Define the new possible tabs
// const TABS = ["Deposit", "Withdraw", "Game", "Penalty", "Bonus"];

// const TabIcon = ({ tab }) => {
//   switch (tab) {
//     case "Deposit":
//       return <FaArrowDown className="mr-2" size={12} />;
//     case "Withdraw":
//       return <FaArrowUp className="mr-2" size={12} />;
//     case "Game":
//       return <FaGamepad className="mr-2" size={12} />;
//     case "Penalty":
//       return <FaExclamationTriangle className="mr-2" size={12} />;
//     case "Bonus":
//       return <FaGift className="mr-2" size={12} />;
//     default:
//       return null;
//   }
// };

// const Transactionhistory = () => {
//   const printRef = useRef(null);
//   const [show, setShow] = useState(false);
//   const [invoiceData, setInvoiceData] = useState({});
//   const [user, setUser] = useState({});
//   const [activeTab, setActiveTab] = useState("Deposit"); // Changed initial tab
//   const [walletData, setWalletData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [walletPages, setWalletPages] = useState(0);
//   const [gameData, setGameData] = useState([]);
//   const [gamePages, setGamePages] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const [pageNumber, setPageNumber] = useState(0);
//   const limit = 50;

//   const handleClose = () => setShow(false);
//   const handleShow = (data) => {
//     setInvoiceData(data);
//     setShow(true);
//   };

//   const pageprint = () => {
//     let divToPrint = printRef.current;
//     let htmlToPrint = `
//       <style>
//         .invoice { width: 100%; }
//         table, td, th { border: 1px solid black; border-collapse: collapse; }
//         td, th { padding: 8px; }
//       </style>
//     `;
//     htmlToPrint += divToPrint.outerHTML;
//     let newWin = window.open("");
//     newWin.document.write(htmlToPrint);
//     newWin.print();
//     newWin.close();
//   };

//   const dateFormat = (e) => {
//     const date = new Date(e);
//     return date.toLocaleString("default", {
//       month: "short",
//       day: "numeric",
//       hour: "numeric",
//       hour12: true,
//       minute: "numeric",
//     });
//   };

//   const fetchUser = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await axios.get(`https://api.kakaking.in/me`, { headers });
//       setUser(res.data);
//       // Fetch all necessary data when component mounts
//       fetchWalletData(res.data._id, pageNumber);
//       fetchGameData(res.data._id, pageNumber);
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     }
//   };

//   const fetchWalletData = async (id, page) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       // NOTE: Assuming this endpoint fetches ALL wallet-related transactions (deposit, withdraw, penalty, bonus)
//       const res = await axios.get(
//         `https://api.kakaking.in/temp/deposite/${id}?page=${page}&_limit=${limit}`,
//         { headers }
//       );
//       setWalletData(res.data.ress);
//       setWalletPages(res.data.totalPages);
//     } catch (error) {
//       console.error("Error fetching wallet data:", error);
//     }
//   };

//   const fetchGameData = async (id, page) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     setIsLoading(true);
//     try {
//       const res = await axios.get(
//         `https://api.kakaking.in/game/history/user/${id}?page=${page}&_limit=${limit}`,
//         { headers }
//       );
//       const validGames = res.data.data.filter(
//         (g) => g.Status === "completed" || g.Status === "cancelled" || g.Status === "conflict"
//       );
//       setGameData(validGames);
//       setGamePages(res.data.totalPages);
//     } catch (error) {
//       console.error("Error fetching game data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUser();
//     // eslint-disable-next-line
//   }, [pageNumber]);

//   // Effect to filter data based on the active tab
//   useEffect(() => {
//     const reqTypeMap = {
//       "Deposit": "deposit",
//       "Withdraw": "withdraw",
//       "Penalty": "penalty",
//       "Bonus": "bonus",
//     };

//     if (activeTab in reqTypeMap) {
//       const reqType = reqTypeMap[activeTab];
//       setFilteredData(walletData.filter((c) => c.Req_type === reqType));
//     } else {
//       // Clear filtered data for the 'Game' tab, as it uses gameData
//       setFilteredData([]);
//     }
//     // Note: The total pages logic for Wallet tabs currently assumes all types are fetched in `fetchWalletData` and uses the same `walletPages` count.
//   }, [activeTab, walletData]);

//   const handlePageClick = (data) => setPageNumber(data.selected);

//   const handleSupport = (gameId) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${access_token}` };
//     const params = new URLSearchParams();
//     params.append("agent_id", "63b5340bc5d2b82e4652b216");
//     params.append("supportType", "game");
//     params.append("issue", gameId);
//     fetch("https://api.kakaking.in/chat/genrate-ticket", {
//       method: "POST",
//       headers,
//       body: params,
//     })
//       .then(response => {
//         if (!response.ok) throw new Error("Failed to generate ticket");
//         // Optionally show a success message here
//       })
//       .catch(console.error);
//   };

//   const handleRefresh = () => {
//     setPageNumber(0);
//     fetchUser();
//   };

//   // Helper function to get Wallet card specific icon and colors
//   const getWalletCardDetails = (card) => {
//     const type = card.Req_type;
//     let icon = <MonetizationOnIcon fontSize="medium" />;
//     let iconBgColor = "#0047AB"; // Default blue
//     let statusColor = "#dc3545"; // Default danger

//     if (type === "deposit") {
//       icon = <FaArrowDown size={18} />; // Deposit Icon
//       iconBgColor = "#28a745"; // Green for Deposit
//     } else if (type === "withdraw") {
//       icon = <FaArrowUp size={18} />; // Withdraw Icon
//       iconBgColor = "#dc3545"; // Red for Withdraw
//     } else if (type === "bonus") {
//       icon = <FaGift size={18} />;
//       iconBgColor = "#ffc107"; // Yellow for Bonus
//     } else if (type === "penalty") {
//       icon = <FaExclamationTriangle size={18} />;
//       iconBgColor = "#dc3545"; // Red for Penalty
//     }

//     if (card.status === "PAID" || card.status === "Deposit Success" || card.status === "Withdraw Success") {
//       statusColor = "#28a745";
//     } else if (card.status === "Pending") {
//       statusColor = "#ffc107";
//     } else {
//       statusColor = "#dc3545";
//     }

//     return { icon, iconBgColor, statusColor };
//   };

//   return (
//     <div className="leftContainer mb_space" style={styles.container}>
//       <div className="container py-5">

//         {/* ==== Header and Refresh Button ==== */}
//         <div className="d-flex justify-content-between align-items-center mb-4 pt-3">
//           <h4 style={{ fontWeight: 700, color: '#1e1e1e' }}>Transaction History</h4>
//           <Button
//             variant="contained"
//             onClick={handleRefresh}
//             style={{
//               backgroundColor: '#fff',
//               color: '#0047AB',
//               border: '1px solid #0047AB',
//               borderRadius: '50%',
//               minWidth: '40px',
//               width: '40px',
//               height: '40px',
//             }}
//             disabled={isLoading}
//           >
//             <IoIosRefresh size={20} className={isLoading ? "spinner-border-sm" : ""} />
//           </Button>
//         </div>

//         {/* ==== Tabs ==== */}
//         <div className="d-flex justify-content-start flex-wrap gap-2 mb-4">
//           {TABS.map((tab) => (
//             <button
//               key={tab}
//               className={`d-flex align-items-center`}
//               style={{
//                 ...styles.tabButton,
//                 ...(activeTab === tab ? styles.activeTab : styles.inactiveTab),
//               }}
//               onClick={() => {
//                 setActiveTab(tab);
//                 setPageNumber(0);
//               }}
//             >
//               <TabIcon tab={tab} />
//               {tab}
//             </button>
//           ))}
//         </div>

//         {/* ==== WALLET / DEPOSIT / WITHDRAW / BONUS / PENALTY CARDS (COMPACT) ==== */}
//         {activeTab !== "Game" && (
//           <div className="row justify-content-center">
//             {filteredData.length > 0 ? (
//               filteredData.map((card, index) => {
//                 const isPositive = card.Req_type === "deposit" || card.Req_type === "bonus";
//                 const amountSign = isPositive ? "+" : "-";
//                 const { icon, iconBgColor, statusColor } = getWalletCardDetails(card);
//                 const primaryDetail = card.Req_type === "bonus" || card.Req_type === "penalty" ?
//                   { label: "Reason", value: card?.txn_msg || "—" } :
//                   { label: "Reference ID", value: card?.txn_msg || "—" };

//                 return (
//                   <div className="col-md-6 col-lg-5 col-12 mb-3" key={index}>
//                     <div className="card shadow-sm" style={styles.card}>

//                       <div style={styles.cardBody}>
//                         {/* Left Icon/Indicator */}
//                         <div style={styles.iconBox(iconBgColor)}>
//                           {icon}
//                         </div>

//                         {/* Center Details */}
//                         <div style={styles.mainDetails}>
//                           <div className="d-flex justify-content-between align-items-center">
//                             <span style={{ fontWeight: "700", fontSize: '15px', textTransform: "uppercase" }}>
//                               {card.Req_type}
//                             </span>
//                             <span style={styles.amountText(statusColor)}>
//                               {amountSign}₹{card.amount}
//                             </span>
//                           </div>
//                           <div className="d-flex justify-content-between align-items-center mt-1">
//                             <span style={styles.detailLabel}>
//                               {primaryDetail.label}
//                             </span>
//                             <span style={styles.detailValue}>
//                               {primaryDetail.value}
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Footer (Time, Balance, Status) */}
//                       <div style={styles.footer}>
//                         <div className="d-flex align-items-center">
//                           <AccessTimeIcon fontSize="inherit" className="mr-1" style={{ color: '#0047AB' }} />
//                           {dateFormat(card.createdAt)}
//                         </div>
//                         <div>
//                           Status: <span style={{ color: statusColor, fontWeight: '700' }}>
//                             {card.status}
//                           </span>
//                         </div>
//                         <div className="d-flex align-items-center">
//                           <FaWallet size={10} className="mr-1" style={{ color: '#0047AB' }} />
//                           Closing Bal: ₹{card.closing_balance || "—"}
//                         </div>
//                       </div>

//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               <div className="text-center my-5">
//                 <img
//                   src={process.env.PUBLIC_URL + "/images/notransactionhistory.png"}
//                   alt="no data"
//                   width={220}
//                 />
//                 <h6 className="mt-2 text-muted">No {activeTab} Transactions</h6>
//               </div>
//             )}
//           </div>
//         )}

//         {/* ==== GAME HISTORY CARDS (COMPACT) ==== */}
//         {activeTab === "Game" && (
//           <div className="row justify-content-center">
//             {isLoading ? (
//               <div className="text-center mt-5">
//                 <Spinner animation="border" variant="primary" /> <p className="mt-2 text-muted">Loading Game History...</p>
//               </div>
//             ) : gameData.length > 0 ? (
//               gameData.map((card, index) => {
//                 const isCancelled = card.Status === "cancelled";
//                 const isConflict = card.Status === "conflict";
//                 const isWin = !isCancelled && !isConflict && card.Winner?._id === user._id;
//                 const isLoss = !isCancelled && !isConflict && !isWin;

//                 // 🔥 Closing Balance Logic
//                 const closingBalance = isWin
//                   ? card?.Winner_closingbalance
//                   : card?.Loser_closingbalance;

//                 let iconBgColor = "#6c757d"; // default gray
//                 let resultText = "CANCELLED";

//                 if (isConflict) {
//                   iconBgColor = "#ffc107";
//                   resultText = "CONFLICT";
//                 } else if (isWin) {
//                   iconBgColor = "#28a745";
//                   resultText = "WIN";
//                 } else if (isLoss) {
//                   iconBgColor = "#dc3545";
//                   resultText = "LOSS";
//                 }

//                 const opponentName = card.Accepetd_By && card.Accepetd_By._id === user._id
//                   ? card?.Created_by?.Name
//                   : card?.Accepetd_By?.Name || "N/A";

//                 return (
//                   <div className="col-md-6 col-lg-5 col-12 mb-3" key={index}>
//                     <div className="card shadow-sm" style={styles.card}>

//                       <div style={styles.cardBody}>
//                         <div style={styles.iconBox(iconBgColor)}>
//                           <FaGamepad size={20} />
//                         </div>

//                         <div style={styles.mainDetails}>
//                           <div className="d-flex justify-content-between align-items-center">
//                             <span style={{ fontWeight: "700", fontSize: '15px', textTransform: "uppercase", color: iconBgColor }}>
//                               {resultText}
//                             </span>
//                             <span style={styles.amountText(iconBgColor)}>
//                               {isCancelled || isConflict ? "₹0" : (
//                                 <>
//                                   {isWin ? "+" : "-"}₹
//                                   {isWin ? card.winnAmount : card.Game_Ammount}
//                                 </>
//                               )}
//                             </span>

//                           </div>
//                           <div className="d-flex justify-content-between align-items-center mt-1">
//                             <span style={styles.detailLabel}>
//                               OPPONENT
//                             </span>
//                             <span style={styles.detailValue}>
//                               {opponentName}
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       <div style={styles.footer}>
//                         <div className="d-flex align-items-center">
//                           <AccessTimeIcon fontSize="inherit" className="mr-1" style={{ color: '#0047AB' }} />
//                           {dateFormat(card.createdAt)}
//                         </div>
//                         <div>
//                           Status: <span style={{ color: iconBgColor, fontWeight: '700' }}>
//                             {card?.Status}
//                           </span>
//                         </div>
//                         <div>
//                         Closing Balance: <span style={{ color: iconBgColor, fontWeight: '700' }}>
//                             {closingBalance}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               <div className="text-center my-5">
//                 <img
//                   src={process.env.PUBLIC_URL + "/images/nogamehistory.png"}
//                   alt="no data"
//                   width={250}
//                 />
//                 <h6 className="mt-2 text-muted">No Game History</h6>
//               </div>
//             )}
//           </div>
//         )}


//         {/* ==== PAGINATION ==== */}
//         {((activeTab === "Game" && gamePages > 1) || (activeTab !== "Game" && walletPages > 1)) && (
//           <div className="d-flex justify-content-center mt-4">
//             <ReactPaginate
//               previousLabel={"←"}
//               nextLabel={"→"}
//               breakLabel={"..."}
//               pageCount={activeTab === "Game" ? gamePages : walletPages}
//               onPageChange={handlePageClick}
//               containerClassName={"pagination"}
//               activeClassName={"active"}
//               pageLinkClassName={"page-link"}
//               previousLinkClassName={"page-link"}
//               nextLinkClassName={"page-link"}
//               breakLinkClassName={"page-link"}
//               style={{
//                 display: 'flex',
//                 listStyle: 'none',
//                 padding: 0,
//               }}
//             />
//           </div>
//         )}

//         <Invoice
//           pageprint={pageprint}
//           handleClose={handleClose}
//           show={show}
//           printRef={printRef}
//           invoice_data={invoiceData}
//         />
//       </div>
//     </div>
//   );
// };

// export default Transactionhistory;


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { AiOutlineDownload } from "react-icons/ai";
import { FaGamepad, FaWallet, FaGift, FaExclamationTriangle, FaArrowUp, FaArrowDown } from "react-icons/fa";
import Invoice from "./Invoice";
import Spinner from "react-bootstrap/Spinner";
import { Button } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaidIcon from '@mui/icons-material/Paid';
import { IoIosRefresh } from "react-icons/io";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


// Custom styles for a more compact and attractive theme
const styles = {
  container: {
    background: "#f7f8fc", // Light gray background
    minHeight: "100vh",
    paddingTop: "10px",
  },
  card: {
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
    background: "#ffffff",
    border: "1px solid #e0e0e0",
    padding: "0px", // Minimal padding on the card itself
  },
  // The main content area of the card
  cardBody: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 15px',
  },
  iconBox: (color) => ({
    backgroundColor: color,
    color: "#fff",
    borderRadius: "8px",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "15px",
    flexShrink: 0, // Prevent shrinking
  }),
  mainDetails: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 0,
  },
  amountText: (color) => ({
    fontWeight: "700",
    fontSize: "16px",
    color: color,
    whiteSpace: 'nowrap',
  }),
  detailLabel: {
    fontSize: "10px",
    color: "#999",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  detailValue: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#333",
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 15px',
    borderTop: '1px dashed #f0f0f0',
    fontSize: '11px',
    color: '#666',
  },
  // FIXED: Added whiteSpace nowrap for inline appearance
  tabButton: {
    borderRadius: "20px",
    padding: "6px 14px",
    fontWeight: "600",
    fontSize: "13px",
    transition: "background-color 0.3s, color 0.3s",
    whiteSpace: "nowrap", 
    border: "none",
    flexShrink: 0
  },
  activeTab: {
    backgroundColor: "#0047AB",
    color: "#fff",
    border: "1px solid #0047AB",
    boxShadow: "0 2px 5px rgba(0, 71, 171, 0.2)",
  },
  inactiveTab: {
    backgroundColor: "transparent",
    color: "#6c757d",
    border: "1px solid #ced4da",
  },
  // NEW: Added container for horizontal scrolling
  tabScrollContainer: {
    display: 'flex',
    overflowX: 'auto',
    gap: '8px',
    paddingBottom: '10px',
    msOverflowStyle: 'none',  /* IE and Edge */
    scrollbarWidth: 'none',   /* Firefox */
  }
};

const TABS = ["Deposit", "Withdraw", "Game", "Penalty", "Bonus"];

const TabIcon = ({ tab }) => {
  switch (tab) {
    case "Deposit":
      return <FaArrowDown className="mr-2" size={12} />;
    case "Withdraw":
      return <FaArrowUp className="mr-2" size={12} />;
    case "Game":
      return <FaGamepad className="mr-2" size={12} />;
    case "Penalty":
      return <FaExclamationTriangle className="mr-2" size={12} />;
    case "Bonus":
      return <FaGift className="mr-2" size={12} />;
    default:
      return null;
  }
};

const Transactionhistory = () => {
  const printRef = useRef(null);
  const [show, setShow] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [user, setUser] = useState({});
  const [activeTab, setActiveTab] = useState("Deposit"); 
  const [walletData, setWalletData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [walletPages, setWalletPages] = useState(0);
  const [gameData, setGameData] = useState([]);
  const [gamePages, setGamePages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const limit = 50;

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setInvoiceData(data);
    setShow(true);
  };

  const pageprint = () => {
    let divToPrint = printRef.current;
    let htmlToPrint = `
      <style>
        .invoice { width: 100%; }
        table, td, th { border: 1px solid black; border-collapse: collapse; }
        td, th { padding: 8px; }
      </style>
    `;
    htmlToPrint += divToPrint.outerHTML;
    let newWin = window.open("");
    newWin.document.write(htmlToPrint);
    newWin.print();
    newWin.close();
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
  };

  const fetchUser = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await axios.get(`https://api.kakaking.in/me`, { headers });
      setUser(res.data);
      fetchWalletData(res.data._id, pageNumber);
      fetchGameData(res.data._id, pageNumber);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchWalletData = async (id, page) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await axios.get(
        `https://api.kakaking.in/temp/deposite/${id}?page=${page}&_limit=${limit}`,
        { headers }
      );
      setWalletData(res.data.ress);
      setWalletPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    }
  };

  const fetchGameData = async (id, page) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    setIsLoading(true);
    try {
      const res = await axios.get(
        `https://api.kakaking.in/game/history/user/${id}?page=${page}&_limit=${limit}`,
        { headers }
      );
      const validGames = res.data.data.filter(
        (g) => g.Status === "completed" || g.Status === "cancelled" || g.Status === "conflict"
      );
      setGameData(validGames);
      setGamePages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching game data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [pageNumber]);

  useEffect(() => {
    const reqTypeMap = {
      "Deposit": "deposit",
      "Withdraw": "withdraw",
      "Penalty": "penalty",
      "Bonus": "bonus",
    };

    if (activeTab in reqTypeMap) {
      const reqType = reqTypeMap[activeTab];
      setFilteredData(walletData.filter((c) => c.Req_type === reqType));
    } else {
      setFilteredData([]);
    }
  }, [activeTab, walletData]);

  const handlePageClick = (data) => setPageNumber(data.selected);

  const handleRefresh = () => {
    setPageNumber(0);
    fetchUser();
  };

  const getWalletCardDetails = (card) => {
    const type = card.Req_type;
    let icon = <MonetizationOnIcon fontSize="medium" />;
    let iconBgColor = "#0047AB"; 
    let statusColor = "#dc3545"; 

    if (type === "deposit") {
      icon = <FaArrowDown size={18} />; 
      iconBgColor = "#28a745"; 
    } else if (type === "withdraw") {
      icon = <FaArrowUp size={18} />; 
      iconBgColor = "#dc3545"; 
    } else if (type === "bonus") {
      icon = <FaGift size={18} />;
      iconBgColor = "#ffc107"; 
    } else if (type === "penalty") {
      icon = <FaExclamationTriangle size={18} />;
      iconBgColor = "#dc3545"; 
    }

    if (card.status === "PAID" || card.status === "Deposit Success" || card.status === "Withdraw Success") {
      statusColor = "#28a745";
    } else if (card.status === "Pending") {
      statusColor = "#ffc107";
    } else {
      statusColor = "#dc3545";
    }

    return { icon, iconBgColor, statusColor };
  };

  return (
    <div className="leftContainer mb_space" style={styles.container}>
      <div className="container py-5">

        {/* ==== Header and Refresh Button ==== */}
        <div className="d-flex justify-content-between align-items-center mb-4 pt-5">
          <h4 style={{ fontWeight: 700, color: '#1e1e1e' }}>Transaction History</h4>
          <Button
            variant="contained"
            onClick={handleRefresh}
            style={{
              backgroundColor: '#fff',
              color: '#0047AB',
              border: '1px solid #0047AB',
              borderRadius: '50%',
              minWidth: '40px',
              width: '40px',
              height: '40px',
            }}
            disabled={isLoading}
          >
            <IoIosRefresh size={20} className={isLoading ? "spinner-border-sm" : ""} />
          </Button>
        </div>

        {/* ==== Tabs (FIXED TO INLINE ROW) ==== */}
        <div style={styles.tabScrollContainer} className="no-scrollbar">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`d-flex align-items-center`}
              style={{
                ...styles.tabButton,
                ...(activeTab === tab ? styles.activeTab : styles.inactiveTab),
              }}
              onClick={() => {
                setActiveTab(tab);
                setPageNumber(0);
              }}
            >
              <TabIcon tab={tab} />
              {tab}
            </button>
          ))}
        </div>

        {/* ==== WALLET / DEPOSIT / WITHDRAW / BONUS / PENALTY CARDS ==== */}
        {activeTab !== "Game" && (
          <div className="row justify-content-center mt-3">
            {filteredData.length > 0 ? (
              filteredData.map((card, index) => {
                const isPositive = card.Req_type === "deposit" || card.Req_type === "bonus";
                const amountSign = isPositive ? "+" : "-";
                const { icon, iconBgColor, statusColor } = getWalletCardDetails(card);
                const primaryDetail = card.Req_type === "bonus" || card.Req_type === "penalty" ?
                  { label: "Reason", value: card?.txn_msg || "—" } :
                  { label: "Reference ID", value: card?.txn_msg || "—" };

                return (
                  <div className="col-md-6 col-lg-5 col-12 mb-3" key={index}>
                    <div className="card shadow-sm" style={styles.card}>
                      <div style={styles.cardBody}>
                        <div style={styles.iconBox(iconBgColor)}>
                          {icon}
                        </div>
                        <div style={styles.mainDetails}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span style={{ fontWeight: "700", fontSize: '15px', textTransform: "uppercase" }}>
                              {card.Req_type}
                            </span>
                            <span style={styles.amountText(statusColor)}>
                              {amountSign}₹{card.amount}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-1">
                            <span style={styles.detailLabel}>{primaryDetail.label}</span>
                            <span style={styles.detailValue}>{primaryDetail.value}</span>
                          </div>
                        </div>
                      </div>
                      <div style={styles.footer}>
                        <div className="d-flex align-items-center">
                          <AccessTimeIcon fontSize="inherit" className="mr-1" style={{ color: '#0047AB' }} />
                          {dateFormat(card.createdAt)}
                        </div>
                        <div>
                          Status: <span style={{ color: statusColor, fontWeight: '700' }}>{card.status}</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <FaWallet size={10} className="mr-1" style={{ color: '#0047AB' }} />
                          Closing Bal: ₹{card.closing_balance || "—"}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-center my-5">
                <h6 className="mt-2 text-muted">No {activeTab} Transactions</h6>
              </div>
            )}
          </div>
        )}

        {/* ==== GAME HISTORY CARDS ==== */}
        {activeTab === "Game" && (
          <div className="row justify-content-center mt-3">
            {isLoading ? (
              <div className="text-center mt-5">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : gameData.length > 0 ? (
              gameData.map((card, index) => {
                const isCancelled = card.Status === "cancelled";
                const isConflict = card.Status === "conflict";
                const isWin = !isCancelled && !isConflict && card.Winner?._id === user._id;
                const isLoss = !isCancelled && !isConflict && !isWin;

                const closingBalance = isWin ? card?.Winner_closingbalance : card?.Loser_closingbalance;

                let iconBgColor = "#6c757d"; 
                let resultText = "CANCELLED";

                if (isConflict) { iconBgColor = "#ffc107"; resultText = "CONFLICT"; }
                else if (isWin) { iconBgColor = "#28a745"; resultText = "WIN"; }
                else if (isLoss) { iconBgColor = "#dc3545"; resultText = "LOSS"; }

                const opponentName = card.Accepetd_By && card.Accepetd_By._id === user._id
                  ? card?.Created_by?.Name
                  : card?.Accepetd_By?.Name || "N/A";

                return (
                  <div className="col-md-6 col-lg-5 col-12 mb-3" key={index}>
                    <div className="card shadow-sm" style={styles.card}>
                      <div style={styles.cardBody}>
                        <div style={styles.iconBox(iconBgColor)}>
                          <FaGamepad size={20} />
                        </div>
                        <div style={styles.mainDetails}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span style={{ fontWeight: "700", fontSize: '15px', textTransform: "uppercase", color: iconBgColor }}>
                              {resultText}
                            </span>
                            <span style={styles.amountText(iconBgColor)}>
                              {isCancelled || isConflict ? "₹0" : <>{isWin ? "+" : "-"}₹{isWin ? card.winnAmount : card.Game_Ammount}</>}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-1">
                            <span style={styles.detailLabel}>OPPONENT</span>
                            <span style={styles.detailValue}>{opponentName}</span>
                          </div>
                        </div>
                      </div>
                      <div style={styles.footer}>
                        <div className="d-flex align-items-center">
                          <AccessTimeIcon fontSize="inherit" className="mr-1" style={{ color: '#0047AB' }} />
                          {dateFormat(card.createdAt)}
                        </div>
                        <div>Status: <span style={{ color: iconBgColor, fontWeight: '700' }}>{card?.Status}</span></div>
                        <div>Bal: <span style={{ fontWeight: '700' }}>₹{closingBalance}</span></div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-center my-5">
                <h6 className="mt-2 text-muted">No Game History</h6>
              </div>
            )}
          </div>
        )}

        {/* ==== PAGINATION ==== */}
        {((activeTab === "Game" && gamePages > 1) || (activeTab !== "Game" && walletPages > 1)) && (
          <div className="d-flex justify-content-center mt-4">
            <ReactPaginate
              previousLabel={"←"}
              nextLabel={"→"}
              pageCount={activeTab === "Game" ? gamePages : walletPages}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"page-link"}
            />
          </div>
        )}

        <Invoice
          pageprint={pageprint}
          handleClose={handleClose}
          show={show}
          printRef={printRef}
          invoice_data={invoiceData}
        />
      </div>
    </div>
  );
};

export default Transactionhistory;